import { render, staticRenderFns } from "./PlaceholderDifferenze.vue?vue&type=template&id=4237dff1&scoped=true"
import script from "./PlaceholderDifferenze.vue?vue&type=script&lang=js"
export * from "./PlaceholderDifferenze.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderDifferenze.vue?vue&type=style&index=0&id=4237dff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4237dff1",
  null
  
)

export default component.exports